const indianCities = [
  // ── GUJARAT (priority — show first) ──
  'Ahmedabad', 'Surat', 'Rajkot',
  'Vadodara', 'Bhavnagar', 'Jamnagar',
  'Junagadh', 'Gandhinagar', 'Anand',
  'Nadiad', 'Bharuch', 'Valsad',
  'Navsari', 'Morbi', 'Surendranagar',
  'Porbandar', 'Amreli', 'Botad',
  'Dahod', 'Patan', 'Mehsana',
  'Dwarka', 'Somnath', 'Palitana',
  'Saputara', 'Diu', 'Ambaji',
  'Statue of Unity', 'Gir',
  'Kutch', 'Bhuj', 'Mandvi',
  'Anjar', 'Gandhidham',
  'Veraval', 'Dhari', 'Mahuva',

  // ── RAJASTHAN ──
  'Jaipur', 'Jodhpur', 'Udaipur',
  'Kota', 'Ajmer', 'Bikaner',
  'Alwar', 'Bharatpur', 'Sikar',
  'Pali', 'Barmer', 'Jaisalmer',
  'Chittorgarh', 'Mount Abu',
  'Pushkar', 'Nathdwara',

  // ── MAHARASHTRA ──
  'Mumbai', 'Pune', 'Nagpur',
  'Nashik', 'Aurangabad', 'Solapur',
  'Kolhapur', 'Amravati', 'Nanded',
  'Thane', 'Shirdi', 'Mahabaleshwar',
  'Lonavala', 'Alibag',

  // ── MADHYA PRADESH ──
  'Indore', 'Bhopal', 'Gwalior',
  'Jabalpur', 'Ujjain', 'Rewa',
  'Sagar', 'Satna', 'Dewas',
  'Omkareshwar', 'Maheshwar',

  // ── DELHI & NCR ──
  'New Delhi', 'Delhi', 'Noida',
  'Gurgaon', 'Faridabad', 'Ghaziabad',

  // ── UTTAR PRADESH ──
  'Agra', 'Lucknow', 'Varanasi',
  'Kanpur', 'Allahabad', 'Mathura',
  'Vrindavan', 'Ayodhya', 'Meerut',

  // ── HIMACHAL PRADESH ──
  'Shimla', 'Manali', 'Dharamshala',
  'Kullu', 'Dalhousie', 'Kasauli',

  // ── UTTARAKHAND ──
  'Dehradun', 'Haridwar', 'Rishikesh',
  'Nainital', 'Mussoorie', 'Kedarnath',
  'Badrinath', 'Gangotri', 'Yamunotri',

  // ── PUNJAB & HARYANA ──
  'Chandigarh', 'Amritsar', 'Ludhiana',
  'Jalandhar', 'Patiala', 'Ambala',

  // ── KARNATAKA ──
  'Bangalore', 'Mysore', 'Hubli',
  'Mangalore', 'Belgaum', 'Hampi',
  'Coorg',

  // ── TAMIL NADU ──
  'Chennai', 'Coimbatore', 'Madurai',
  'Trichy', 'Salem', 'Tirupati',
  'Rameshwaram', 'Kanyakumari',

  // ── TELANGANA & AP ──
  'Hyderabad', 'Visakhapatnam',
  'Vijayawada', 'Tirupati',

  // ── KERALA ──
  'Kochi', 'Thiruvananthapuram',
  'Kozhikode', 'Thrissur', 'Munnar',
  'Alleppey', 'Wayanad',

  // ── GOA ──
  'Goa', 'Panaji', 'Margao',
  'Vasco Da Gama',

  // ── ODISHA ──
  'Bhubaneswar', 'Puri', 'Cuttack',
  'Rourkela',

  // ── WEST BENGAL ──
  'Kolkata', 'Siliguri', 'Darjeeling',
  'Howrah',

  // ── BIHAR & JHARKHAND ──
  'Patna', 'Gaya', 'Ranchi',
  'Jamshedpur', 'Bodhgaya',

  // ── AIRPORTS (common searches) ──
  'Ahmedabad Airport',
  'Rajkot Airport',
  'Surat Airport',
  'Vadodara Airport',
  'Mumbai Airport',
  'Delhi Airport',
  'Jaipur Airport',
  'Pune Airport',
];

export const GUJARAT_CITIES = [
  'Ahmedabad', 'Surat', 'Rajkot',
  'Vadodara', 'Bhavnagar', 'Jamnagar',
  'Junagadh', 'Gandhinagar', 'Anand',
  'Dwarka', 'Somnath', 'Kutch', 'Bhuj',
  'Porbandar', 'Morbi', 'Amreli',
  'Gandhidham', 'Mehsana', 'Patan',
  'Ambaji', 'Palitana', 'Saputara',
  'Gir', 'Diu', 'Statue of Unity',
  'Surendranagar', 'Bharuch', 'Navsari',
  'Valsad', 'Veraval', 'Nadiad', 'Anjar',
  'Mandvi', 'Botad', 'Dahod', 'Mahuva',
  'Dhari', 'Veraval',
];

const CITY_STATE_ENTRIES = [
  ['Gujarat', [
    'Ahmedabad', 'Surat', 'Rajkot', 'Vadodara', 'Bhavnagar', 'Jamnagar', 'Junagadh', 'Gandhinagar',
    'Anand', 'Nadiad', 'Bharuch', 'Valsad', 'Navsari', 'Morbi', 'Surendranagar', 'Porbandar',
    'Amreli', 'Botad', 'Dahod', 'Patan', 'Mehsana', 'Dwarka', 'Somnath', 'Palitana', 'Saputara',
    'Diu', 'Ambaji', 'Statue of Unity', 'Gir', 'Kutch', 'Bhuj', 'Mandvi', 'Anjar', 'Gandhidham',
    'Veraval', 'Dhari', 'Mahuva', 'Ahmedabad Airport', 'Rajkot Airport', 'Surat Airport', 'Vadodara Airport',
  ]],
  ['Rajasthan', [
    'Jaipur', 'Jodhpur', 'Udaipur', 'Kota', 'Ajmer', 'Bikaner', 'Alwar', 'Bharatpur', 'Sikar', 'Pali',
    'Barmer', 'Jaisalmer', 'Chittorgarh', 'Mount Abu', 'Pushkar', 'Nathdwara', 'Jaipur Airport',
  ]],
  ['Maharashtra', [
    'Mumbai', 'Pune', 'Nagpur', 'Nashik', 'Aurangabad', 'Solapur', 'Kolhapur', 'Amravati', 'Nanded',
    'Thane', 'Shirdi', 'Mahabaleshwar', 'Lonavala', 'Alibag', 'Mumbai Airport', 'Pune Airport',
  ]],
  ['Madhya Pradesh', ['Indore', 'Bhopal', 'Gwalior', 'Jabalpur', 'Ujjain', 'Rewa', 'Sagar', 'Satna', 'Dewas', 'Omkareshwar', 'Maheshwar']],
  ['Delhi NCR', ['New Delhi', 'Delhi', 'Noida', 'Gurgaon', 'Faridabad', 'Ghaziabad', 'Delhi Airport']],
  ['Uttar Pradesh', ['Agra', 'Lucknow', 'Varanasi', 'Kanpur', 'Allahabad', 'Mathura', 'Vrindavan', 'Ayodhya', 'Meerut']],
  ['Himachal Pradesh', ['Shimla', 'Manali', 'Dharamshala', 'Kullu', 'Dalhousie', 'Kasauli']],
  ['Uttarakhand', ['Dehradun', 'Haridwar', 'Rishikesh', 'Nainital', 'Mussoorie', 'Kedarnath', 'Badrinath', 'Gangotri', 'Yamunotri']],
  ['Punjab & Haryana', ['Chandigarh', 'Amritsar', 'Ludhiana', 'Jalandhar', 'Patiala', 'Ambala']],
  ['Karnataka', ['Bangalore', 'Mysore', 'Hubli', 'Mangalore', 'Belgaum', 'Hampi', 'Coorg']],
  ['Tamil Nadu', ['Chennai', 'Coimbatore', 'Madurai', 'Trichy', 'Salem', 'Tirupati', 'Rameshwaram', 'Kanyakumari']],
  ['Telangana & AP', ['Hyderabad', 'Visakhapatnam', 'Vijayawada']],
  ['Kerala', ['Kochi', 'Thiruvananthapuram', 'Kozhikode', 'Thrissur', 'Munnar', 'Alleppey', 'Wayanad']],
  ['Goa', ['Goa', 'Panaji', 'Margao', 'Vasco Da Gama']],
  ['Odisha', ['Bhubaneswar', 'Puri', 'Cuttack', 'Rourkela']],
  ['West Bengal', ['Kolkata', 'Siliguri', 'Darjeeling', 'Howrah']],
  ['Bihar & Jharkhand', ['Patna', 'Gaya', 'Ranchi', 'Jamshedpur', 'Bodhgaya']],
];

export const CITY_STATE = CITY_STATE_ENTRIES.reduce((acc, [state, cities]) => {
  cities.forEach((city) => {
    if (!acc[city]) acc[city] = state;
  });
  return acc;
}, {});

export default indianCities;
